import { createContext } from 'react';
import { VariationContextInterface } from './VariationContextInterface';

const defaultContextValue: VariationContextInterface = {};

export const VariationContext = createContext(defaultContextValue);
